if (!customElements.get("metaltex-history-timeline")) {
  customElements.define(
    "metaltex-history-timeline",
    class MetaltexHistoryTimeline extends HTMLElement {
      connectedCallback() {
        if (this.dataset.init === "1") return;
        this.dataset.init = "1";

        this.slides = Array.from(this.querySelectorAll("[data-history-slide]"));
        this.mediaItems = Array.from(this.querySelectorAll("[data-history-media]"));
        this.dots = Array.from(this.querySelectorAll("[data-history-dot]"));
        this.track = this.querySelector("[data-history-track]");
        this.prevBtn = this.querySelector("[data-history-prev]");
        this.nextBtn = this.querySelector("[data-history-next]");
        this.total = this.slides.length;
        this.index = 0;

        if (this.total < 1) return;

        this.prevBtn && this.prevBtn.addEventListener("click", () => this.goTo(this.index - 1));
        this.nextBtn && this.nextBtn.addEventListener("click", () => this.goTo(this.index + 1));
        this.dots.forEach((dot, i) => {
          dot.addEventListener("click", () => this.goTo(i));
        });

        this.addEventListener("keydown", (e) => {
          if (e.key === "ArrowLeft") this.goTo(this.index - 1);
          if (e.key === "ArrowRight") this.goTo(this.index + 1);
        });

        this.goTo(0, true);
      }

      goTo(nextIndex, instant) {
        if (this.total < 1) return;
        const index = Math.max(0, Math.min(this.total - 1, nextIndex));
        this.index = index;

        this.slides.forEach((slide, i) => {
          slide.classList.toggle("is-active", i === index);
          slide.setAttribute("aria-hidden", i === index ? "false" : "true");
        });
        this.mediaItems.forEach((item, i) => {
          item.classList.toggle("is-active", i === index);
          item.setAttribute("aria-hidden", i === index ? "false" : "true");
        });
        this.dots.forEach((dot, i) => {
          const active = i === index;
          const passed = i <= index;
          dot.classList.toggle("is-active", active);
          dot.classList.toggle("is-passed", passed);
          dot.setAttribute("aria-current", active ? "true" : "false");
        });

        if (this.track) {
          const progress = this.total <= 1 ? 0 : index / (this.total - 1);
          this.track.style.setProperty("--history-progress", String(progress));
        }

        if (this.prevBtn) this.prevBtn.disabled = index === 0;
        if (this.nextBtn) this.nextBtn.disabled = index === this.total - 1;

        if (!instant) {
          this.dispatchEvent(
            new CustomEvent("history-timeline:change", {
              detail: { index },
              bubbles: true,
            }),
          );
        }
      }
    },
  );
}
